import { api_GET_External } from "../api/_axios.js";

const cep_api =
{
    get: function(cep){
        const promise = new Promise((resolve, reject) => { 
            api_GET_External(`https://viacep.com.br/ws/${cep.replace("-", "")}/json/`).then(result => {
                resolve(result)
            });
        });

        return promise;
    },

}

export default cep_api
